/** Persist cue-panel size without expanding the shared settings schema. */
export const CUE_PANEL_SIZE_KEY = 'rikosub:cue-panel-size';

export type CuePanelSize = {
  /** Landscape / tablet side panel width in px */
  widthPx: number;
  /** Portrait bottom-sheet max-height in px */
  heightPx: number;
};

export const DEFAULT_CUE_PANEL_SIZE: CuePanelSize = {
  widthPx: 320,
  heightPx: 420,
};

const MIN_WIDTH = 240;
const MAX_WIDTH = 560;
const MIN_HEIGHT = 220;
const MAX_HEIGHT = 720;

export function clampCuePanelWidth(px: number): number {
  return Math.min(MAX_WIDTH, Math.max(MIN_WIDTH, Math.round(px)));
}

export function clampCuePanelHeight(px: number): number {
  return Math.min(MAX_HEIGHT, Math.max(MIN_HEIGHT, Math.round(px)));
}

export function readCuePanelSize(storage: Storage = localStorage): CuePanelSize {
  try {
    const raw = storage.getItem(CUE_PANEL_SIZE_KEY);
    if (!raw) return { ...DEFAULT_CUE_PANEL_SIZE };
    const parsed = JSON.parse(raw) as Partial<CuePanelSize>;
    return {
      widthPx: clampCuePanelWidth(Number(parsed.widthPx) || DEFAULT_CUE_PANEL_SIZE.widthPx),
      heightPx: clampCuePanelHeight(Number(parsed.heightPx) || DEFAULT_CUE_PANEL_SIZE.heightPx),
    };
  } catch {
    return { ...DEFAULT_CUE_PANEL_SIZE };
  }
}

export function writeCuePanelSize(size: CuePanelSize, storage: Storage = localStorage): void {
  storage.setItem(
    CUE_PANEL_SIZE_KEY,
    JSON.stringify({
      widthPx: clampCuePanelWidth(size.widthPx),
      heightPx: clampCuePanelHeight(size.heightPx),
    }),
  );
}
